<script>
export default {
    name: "MorgueGatePass",

    props: {
        patient: Object,
        showModal: Boolean,
    },

    methods: {

        printGatepass() {
           let url = `?PatientID=${this.patient.patientID}&DischargeId=${this.patient.dischargeID}`

            window.open(`/morgue/gatepass-print${url}`, 
                '_blank', 
                `GatePassPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Gate Pass</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full mb-3">
                <tail-address-header></tail-address-header>
            </div>
            <div class="w-full p-1 text-center my-3">
            <h5 class="font-medium text-base uppercase">Morgue Gate Pass</h5> 
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Name: {{ patient.patient}}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">MRN: {{ patient.patientID }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Morque No: {{ patient.morgueNo|'-' }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">National Id: {{ patient.nationalid|'-' }}</h5>
            </div>
             
        </div> 
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="md:flex-1 my-1">
                <h5 class="font-semibold text-sm">Date Admitted: {{ patient.dateAdmitted | dateFormat }}</h5> 
            </div>
            <div class="md:flex-1 my-1">
                <h5 class="font-semibold text-sm">Date Discharged: {{ patient.dischargeDate | dateFormat }}</h5>
            </div> <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Days: {{ patient.days }}</h5>
            </div>
            
             
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Package: {{ patient.package|'-' }}</h5>
            </div>
             
                <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Death Cert: {{ patient.deathCertNo|'-' }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-medium text-base">Burial Permit: {{ patient.burialPermit|'-' }}</h5>
            </div> 
        </div>
         <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Brought By: {{ patient.broughtBy|'-'}}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Brought By Relationship: {{ patient.broughtByRelationship|'-' }}</h5>
            </div> <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Brought By ID: {{ patient.broughtByIdNo|'-' }}</h5>
            </div>
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">Place of Death: {{ patient.placeOfDeath|'-' }}</h5>
            </div><div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">Burial Place: {{ patient.village|'-' }}</h5>
            </div><div class="md:w-1/4 w-1/2">
                <h5 class="font-semibold text-sm">Location: {{ patient.location|'-' }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Subcounty: {{ patient.subcounty|'-'}}</h5>
            </div>
            
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Collected By: {{ patient.collectedBy|'-' }}</h5>
            </div><div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Collected By Id: {{ patient.collectedByIdNo|'-'  }}</h5>
            </div><div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Collected by Tel: {{ patient.collectedByTel|'-'}}</h5>
            </div>   
        </div>
       
         
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            @click.prevent="printGatepass"
            class="btn-sm btn-info text-xs rounded mr-6">
                <i class="fa fa-print"></i> Print</button>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>
